// extracted by mini-css-extract-plugin
export default {"container":"Index_container__YnpbO","link":"Index_link__ixUBC"};